import { useGetEnergyType } from "../../../../api/common";
import {
  useGetHeatSourceType,
  useGetRefrigerantSourceType,
  useGetWaterSourceType
} from "../../../../api/static-data";

/**
 * The only place the four facility static-data source-type queries are called.
 * Country fetching is intentionally excluded — the details drawer receives
 * `countries` as a prop (matching legacy), so it must not call useGetCountries.
 */
export const useFacilitySourceTypeOptions = () => {
  const { data: energyOptions, status: energyStatus, fetchStatus: energyFetchStatus } = useGetEnergyType();
  const { data: heatOptions, status: heatStatus, fetchStatus: heatFetchStatus } = useGetHeatSourceType();
  const { data: waterOptions, status: waterStatus, fetchStatus: waterFetchStatus } = useGetWaterSourceType();
  const {
    data: refrigerantOptions,
    status: refrigerantStatus,
    fetchStatus: refrigerantFetchStatus
  } = useGetRefrigerantSourceType();

  const isOptionsLoading =
    (energyStatus === "loading" && energyFetchStatus === "fetching") ||
    (heatStatus === "loading" && heatFetchStatus === "fetching") ||
    (waterStatus === "loading" && waterFetchStatus === "fetching") ||
    (refrigerantStatus === "loading" && refrigerantFetchStatus === "fetching");

  return { energyOptions, heatOptions, waterOptions, refrigerantOptions, isOptionsLoading };
};
